export default __webpack_public_path__ + "static/dudu-feature1-8cf96bea4e6c2e5f9682c49479ff743e.png";